'use client';

import { useEffect } from 'react';
import {
  releaseHomepageLenis,
  retainHomepageLenis,
  shouldUseHomepageLenis,
} from 'utils/homepageLenis';
import './homepageLenis.css';

/**
 * Enables Lenis + ScrollTrigger scrollerProxy on the homepage so pinned /
 * scrubbed v3 sections don't hitch on native wheel. Renders nothing.
 */
export const HomepageLenis = () => {
  useEffect(() => {
    const queries = [
      window.matchMedia('(prefers-reduced-motion: reduce)'),
      window.matchMedia('(min-width: 992px)'),
      window.matchMedia('(pointer: fine)'),
    ];
    let active = false;

    const sync = () => {
      if (!shouldUseHomepageLenis()) {
        if (active) {
          releaseHomepageLenis();
          active = false;
        }
        return;
      }
      if (!active) {
        retainHomepageLenis();
        active = true;
      }
    };

    sync();
    queries.forEach((q) => q.addEventListener('change', sync));
    return () => {
      queries.forEach((q) => q.removeEventListener('change', sync));
      if (active) releaseHomepageLenis();
    };
  }, []);

  return null;
};

export default HomepageLenis;
